@if (_initialized) {
    <span>
        <span class="lg-month-range-selector-popup__select-all" (click)="_selectAll()">{{
            "FW._Directives.Month_Range_Selector__All_months" | lgTranslate
        }}</span>
        @for (m of _months; track m; let index = $index) {
            <span
                #month
                class="lg-month-range-selector-popup__month"
                [attr.data-id]="index + 1"
                [ngClass]="_className(index)"
                (mouseover)="_onMouseOver($event, index + 1)"
                (mouseout)="_onMouseOut($event, index + 1)"
                (mousedown)="_onMouseDown(index + 1)"
                title="{{ _getMonthTooltip(index + 1) | capitalize }}"
                (click)="_onClick($event)"
                >{{ _shortNames[m] | removeSymbol: "DOT" | capitalize }}</span
            >
        }
    </span>
}
